import {
  object, string, oneOf, shape, oneOfType, objectOf, number,
} from 'prop-types';
import {
  map, toPairs, compose, mergeRight, reduce,
} from 'ramda';

import { AMOUNT_TYPES, AMOUNT_FORMAT_TYPES } from '@ezugi/constants';
import { isNil, isObject, formatAmount } from '@ezugi/utils';

/**
 * @deprecated
 * Use hook variant instead
 */
const Amount = ({ children, values, format, currency }) => {
  if (isNil(values) || !isObject(values)) {
    return null;
  }

  const displayValues = compose(
    reduce(mergeRight, {}),
    map(([ key, { value, type, showCurrencySymbol, showCurrencyCode } ]) => ({
      [key]: formatAmount(value, type, format, currency, showCurrencySymbol, showCurrencyCode),
    })),
    toPairs
  )(values);

  return children(displayValues);
};

Amount.formatAmount = formatAmount;
Amount.AMOUNT_TYPES = AMOUNT_TYPES;
Amount.AMOUNT_FORMAT_TYPES = AMOUNT_FORMAT_TYPES;

const valueType = shape({
  value: oneOfType([ number, string ]),
  type: oneOf(Object.values(AMOUNT_TYPES)),
});

Amount.propTypes = {
  values: objectOf(valueType).isRequired,
  format: object.isRequired,
  type: string,
  currency: string,
};

export default Amount;
